import './Header.scss';
import { HeaderPopup } from './Popup';

const replaceSearchButton = () => {
    const link = document.querySelector('.header__action-button--search');
    if (link) {
        const button = document.createElement('BUTTON');
        button.innerHTML = link.innerHTML;
        button.className = link.className;
        button.setAttribute('aria-controls', link.getAttribute('aria-controls'));
        link.parentElement.insertBefore(button, link);
        link.remove();
    }
};
replaceSearchButton();

HeaderPopup.init();
